import { useNavigate } from "react-router-dom";
import "./BackButton.css"; // Globale CSS-Datei für den BackButton

export default function BackButton({ to = "/" }) {  // Standard-Zurück zu "/"
    const navigate = useNavigate();

    return (
        <div className="back-button-container">
            <button className="back-button" onClick={() => navigate(to)}>
                🔙 Zurück
            </button>
        </div>
    );
}